import { Component, h, Prop } from "@stencil/core";

/**
 * Contact Card for displaying contact details
 * @slot title - The title of the contact (e.g. name)
 * @slot sub-title - The sub title of the contact (e.g. job title)
 * @slot text - The main text of the contact (e.g. description)
 * @slot details - contact details about the contact (may be used multiple times)
 */
@Component({
    tag: "ux-iws-contact-card",
    styleUrl: "contact-card.scss",
    shadow: true,
})
export class ContactCard {
    /**
     * The image URL of the contact (if left empty, an avatar icon will be used)
     */
    @Prop() image: string = "";

    /**
     * Alt Text for the image (only used when an image is supplied)
     */
    @Prop() imageAlt: string = "";

    render() {
        return (
            <div class="container">
                <div class="image">
                    {this.image ? (
                        <div>
                            <img
                                alt={this.imageAlt}
                                src={this.image}
                                loading="lazy"
                            />
                        </div>
                    ) : (
                        <ux-icon name="avatar"></ux-icon>
                    )}
                </div>
                <div class="content">
                    <slot name="title"></slot>
                    <slot name="sub-title"></slot>
                    <slot name="text"></slot>
                    <slot name="details"></slot>
                </div>
            </div>
        );
    }
}
